/* eslint-disable react-refresh/only-export-components */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "~/app-router";
import LoginPage from "./login";
import { z } from "zod";
import DocumentDeclarationPage from "./agent/document-declaration";
import WorklistPage from "./supervisor/worklist";
import ViewPage from "./supervisor/worklist/view";
import SupervisorLayout from "./supervisor";
import UsersPage from "./supervisor/users";
import LargeDataMasterPage from "./supervisor/LargeDataMaster";
import ReportsPage from "./supervisor/reports";
import TemplatesPage from "./supervisor/templates";
import TemplateEditHeaderPage from "./supervisor/templates/edit/header";
import ExtractionPage from "./supervisor/extraction";

import AHTMonitoringPage from "./supervisor/ahtmonitoring";
import TemplateEditTablePage from "./supervisor/templates/edit/table";
import ReasonCodePage from "./supervisor/reasoncode";
import EditPage from "./supervisor/worklist/edit";
import GlobalExceptionPage from "./GlobalException";
import ServerStatusPage from "./GlobalException/serverStatus";
import BusinessRulePage from "./businessrule";
import ExceptionComponent from "./supervisor/exception";
import MasterReportsPage from "./supervisor/master";

const loginRouteSchema = z.object({
  code: z.string().optional(),
});

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  validateSearch: (searchParams: any) => loginRouteSchema.parse(searchParams),
  component: () => <LoginPage />,
});

export const agentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/agent/document-declaration",
  component: () => <DocumentDeclarationPage />,
});

export const smeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sme/document-declaration",
  component: () => <DocumentDeclarationPage />,
});
//tgesmeRoute

export const supervisorRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "supervisor-layout",
  component: () => <SupervisorLayout />,
});
export const tgesmeRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/exception",
  component: () => <ExceptionComponent />,
});
export const worklistRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/worklist",
  component: () => <WorklistPage />,
});

export const viewWorklistRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/worklist/view/$taskId",
  component: () => <ViewPage />,
});

export const EditWorklistRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/worklist/edit/$taskId",
  component: () => <EditPage />,
});

export const usersRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/users",
  component: () => <UsersPage />,
});

export const reasoncodeRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/reasoncode",
  component: () => <ReasonCodePage />,
});
const reportQuerySchema = z.object({
  name: z.string(),
});
const masterReportQuerySchema = z.object({
  master_name: z.string(),
});

export const reportsRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/reports",
  validateSearch: (searchParams: any) => reportQuerySchema.parse(searchParams),
  component: () => <ReportsPage />,
});
export const ahtRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/ahtmonitoring",
  validateSearch: (searchParams: any) => reportQuerySchema.parse(searchParams),
  component: () => <AHTMonitoringPage />,
});
export const extractionRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/extraction",
  component: () => <ExtractionPage />,
});

export const ahtmonitoringRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/ahtmonitoring",
  component: () => <AHTMonitoringPage />,
});

export const templateRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/templates",
  component: () => <TemplatesPage />,
});

// export const exceptionRoute = createRoute({
//   getParentRoute: () => supervisorRoute,
//   path: "/supervisor/exception",
//   component: () => <ExceptionPage />,
// });

const templateEditSchema = z.object({
  id: z.number(),
});

export const templateEditHeaderRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/templates/edit/header",
  validateSearch: (searchParams: any) => templateEditSchema.parse(searchParams),
  component: () => <TemplateEditHeaderPage />,
});

export const templateEditTableRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/supervisor/templates/edit/table",
  validateSearch: (searchParams: any) => templateEditSchema.parse(searchParams),
  component: () => <TemplateEditTablePage />,
});

export const globalExceptionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/globalexception",
  validateSearch: (searchParams: any) => loginRouteSchema.parse(searchParams),
  component: () => <GlobalExceptionPage />,
});
export const ServerStatusPageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/serverstatus",
  validateSearch: (searchParams: any) => loginRouteSchema.parse(searchParams),
  component: () => <ServerStatusPage />,
});
export const businessRuleRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/businessrule",
  validateSearch: (searchParams: any) => loginRouteSchema.parse(searchParams),
  component: () => <BusinessRulePage />,
});
export const mastersRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/masters",
  validateSearch: (searchParams: any) => masterReportQuerySchema.parse(searchParams),
  component: () => <MasterReportsPage />,
});
export const LargeDataMasterRoute = createRoute({
  getParentRoute: () => supervisorRoute,
  path: "/LargeDataMaster",
  validateSearch: (searchParams: any) => masterReportQuerySchema.parse(searchParams),
  component: () => <LargeDataMasterPage />,
});